module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-filter"
  }, [_c('i-popup', {
    attrs: {
      "title": "隐藏显示列",
      "direction": "north",
      "autoClose": false,
      "icon-class": "tofu-icon icon-stop-square"
    }
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('i-checkbox-group', {
    on: {
      "change": _vm.handleCheckChange
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('li', {
      key: field.label,
      staticClass: "list-item"
    }, [_c('i-checkbox', {
      attrs: {
        "label": field.label + ''
      }
    })], 1)
  }))], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-78950426!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/field_filter/src/field_filter.vue
// module id = 669
// module chunks = 0